import React from 'react';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

import * as S from './styles';

// type TooltipProps = React.ComponentProps<typeof TooltipPrimitive.Root> & {

// } // comentado por estar vazio, usar caso necessário

export function HoverCard ({ children, /* ...props */ }: /* TooltipProps */ React.ComponentProps<typeof HoverCardPrimitive.Root>){
  return (
    <HoverCardPrimitive.Root>
      {children}
    </HoverCardPrimitive.Root>
  )
}

export const HoverCardTrigger = HoverCardPrimitive.Trigger;
HoverCardTrigger.displayName = 'HoverCardTrigger';

export const HoverCardPortal = HoverCardPrimitive.Portal;
HoverCardPortal.displayName = 'HoverCardPortal';

// type TooltipContentProps = TooltipPrimitive.TooltipContentProps &
//   React.ComponentProps<typeof S.TooltipPrimitiveContent> & {
// } // comentado por estar vazio, usar caso necessário

export function HoverCardContent({ children, ...props }: /* TooltipContentProps */ HoverCardPrimitive.HoverCardContentProps & React.ComponentProps<typeof S.HoverCardPrimitiveContent>) {
  return (
    <S.HoverCardPrimitiveContent
      {...props}> {children}
    </S.HoverCardPrimitiveContent>
  )
}

export const HoverCardArrow = S.HoverCardArrow;
HoverCardTrigger.displayName = 'HoverCardArrow';
